import {Button, Modal, Alert, Popconfirm, message} from "antd"
import React, {Component, createRef} from "react"
import { deleteSetBasket, getSetBasketDetail } from "../../../../services/api/basketsMergerSetApi"
import ModalBasketsTable from "./ModalBasketsTable"
import releaseBasket from "../../../merger-v2/actions/releaseBasket"

class ModalBasketDetail extends Component {
    state = {
        loading: false,
        error: '',
        basketsDetail: {}
    }

    componentDidMount() {
        // khi mở lần đầu có basketId => fetch luôn
        const { basketId, visible } = this.props
        if (visible && basketId) {
            this.fetchSetBasketDetail(basketId)
        }
    }

    componentDidUpdate(prevProps) {
        // khi thay đổi basketId hoặc mở modal lại => fetch lại data
        const { basketId, visible, reloadFlag } = this.props
        // Nếu props reloadFlag thay đổi → cha vừa reload
        if (prevProps.reloadFlag !== reloadFlag && visible && basketId) {
            this.fetchSetBasketDetail(basketId);
        }

        if ((visible && !prevProps.visible) || basketId !== prevProps.basketId) {
            if (basketId) {
                this.fetchSetBasketDetail(basketId)
            }
        }
    }

    fetchSetBasketDetail = async (basketId) => {
        this.setState({ 
            loading: true, 
            error: '', 
            basketsDetail: null 
        })

        try {
            const { data: response } = await getSetBasketDetail(basketId)
            const { success, data, error } = response
            
            if (!success) throw new Error(error || 'Lỗi khi lấy chi tiết giỏ')
            
            this.setState({
                basketsDetail: data,
                loading: false,
            })
        } catch (err) {
            this.setState({
                error: err.message || 'Không thể tải chi tiết giỏ',
                loading: false,
            })
        }
    }

    onClose = () => {
        this.props.toggleModalBasketDetail()
    }

    onDeleteSetBasket = async(barcode, basketNumber) => {
        const {reload, basketId} = this.props
        this.setState({
            loading: true
        })
        
        try {
            const payload = {
                basket_number: basketNumber
            }
            const {data: responseData} = await deleteSetBasket(barcode, payload)
            const {data, success} = responseData

            if (!success) {
                message.error('Xóa giỏ không thành công!')
                return this.setState({
                    loading: false
                })
            }

            message.success('Xóa giỏ thành công!')

            // await this.fetchSetBasketDetail(basketId)
            await reload()
        } catch (e) {
            message.error(e.message)
        } finally {
            this.setState({
                loading: false
            })
        }
    }

    render() {
        const {visible, basketNumber} = this.props
        const {basketsDetail, loading} = this.state
        const items = basketsDetail && basketsDetail.items ? basketsDetail.items : []
        
        return <Modal visible={visible}
                      title={`Chi tiết giỏ số ${basketNumber}`}
                      className="ModalBasketDetail"
                      closable={true}
                      onCancel={this.onClose}
                      footer={null}
                      width={750}
        >
            <ModalBasketsTable items={items} loading={loading} onDeleteSetBasket={this.onDeleteSetBasket} basketNumber={basketNumber}/>
        </Modal>
    }
}

export default ModalBasketDetail